import { defineStore } from 'pinia'
import { usePagesStore } from './pages'
import httpClient from '@/api/httpClient'
import store from '@/store'

export const useIssueStore = defineStore('issue', {
  state: () => {
    return {
      issue: {
        id: null,
        publication: {},
        title: '',
        slug: '',
        publish_on: null,
        notes: '',
        subsite_id: null
      }
    }
  },

  getters: {
    // Convert the nested publication.id to a publication_id
    forApi: ({ issue }) => {
      const { publication, ...others } = issue

      return { ...others, publication_id: publication.id }
    }
  },

  actions: {
    async fetch({ issueId }) {
      return httpClient.get(`/api/internal/issues/${issueId}`)
        .then(response => {
          this.issue = response.data.issue
        })
        .catch(err => {
          console.error(err)
          store.dispatch('messages/addError', err)
        })
    },

    // The same as fetch, but excludes the ID,
    // since we want to save a new cloned issue with a new ID.
    async fetchForCloning({ issueId }) {
      await this.fetch({ issueId })

      // We don't want to carry these over into the cloned issue
      this.issue.id = null
      this.issue.notes = null
    },

    async save() {
      return await this.issue.id ? this.update() : this.create()
    },

    // Like create but also creates nested pages
    async clone() {
      const pagesStore = usePagesStore()
      // Remove the primary and foreign keys since we want to create new records
      const issue = {
        ...this.forApi,
        id: null,
        pages_attributes: pagesStore.pages.map(page => ({
          ...page,
          id: null,
          issue: null
        }))
      }

      return httpClient.post('/api/internal/issues/', { issue })
        .then(({ data: { issue } }) => {
          this.issue = issue
          store.dispatch('messages/addNotice', 'Issue created')

          return issue
        })
        .catch(err => {
          console.error(err)
          store.dispatch('messages/addError', err)
          throw err
        })
    },

    async create() {
      const issue = this.forApi

      return httpClient.post('/api/internal/issues/', { issue })
        .then(({ data: { issue } }) => {
          this.issue = issue
          store.dispatch('messages/addNotice', 'Issue created')
        })
        .catch(err => {
          console.error(err)
          store.dispatch('messages/addError', err)
          throw err
        })
    },

    async update() {
      const issue = this.forApi

      return httpClient
        .patch(
          `/api/internal/issues/${issue.id}`,
          { issue }
        )
        .then(({ data: { issue } }) => {
          this.issue = issue
          store.dispatch('messages/addNotice', 'Issue saved')
        })
        .catch(err => {
          console.error(err)
          store.dispatch('messages/addError', err)
          throw err
        })
    }
  }
})
